import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Club } from './pages/Club';
import { Calendrier } from './pages/Calendrier';
import { InfosPratiques } from './pages/InfosPratiques';
import { Partenaires } from './pages/Partenaires';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28t4lsf4bmctj">
      <ScrollToTop data-id="element-1" data-mp="28sl511qepuh3" />
      <div className="flex min-h-screen w-full flex-col bg-ink font-sans text-bone" data-id="element-2" data-mp="28s2z1ddy01vz">
        <a href="#contenu" className="zk-focus sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-gold focus:px-4 focus:py-2 focus:font-display focus:text-sm focus:uppercase focus:text-ink" data-id="element-3" data-mp="23t8fuac2cbbc">
          Aller au contenu
        </a>
        <Header data-id="element-4" data-mp="3recf5n6xuth9" />
        <main id="contenu" className="flex-1" data-id="element-5" data-mp="5yk6vxnnffx">
          <Routes data-id="element-6" data-mp="4wylxj0jajy">
            <Route path="/" element={<Home data-id="element-8" data-mp="7st1bvnjh3n" />} data-id="element-7" data-mp="56nfhsbnbo2" />
            <Route path="/le-club" element={<Club data-id="element-10" data-mp="2zmeowbge3q93" />} data-id="element-9" data-mp="2zllf11m4wkmq" />
            <Route path="/calendrier" element={<Calendrier data-id="element-12" data-mp="33mf25srr5vek" />} data-id="element-11" data-mp="2zmwh8wzxlkbq" />
            <Route path="/informations-pratiques" element={<InfosPratiques data-id="element-14" data-mp="33oi337ug18y2" />} data-id="element-13" data-mp="33nq6put0v76q" />
            <Route path="/partenaires" element={<Partenaires data-id="element-16" data-mp="38k6u2msedhir" />} data-id="element-15" data-mp="38l8gtoirzsgb" />
            <Route path="/contact" element={<Contact data-id="element-18" data-mp="3dle30p6a0mr0" />} data-id="element-17" data-mp="38o4gpie6or7e" />
            <Route path="*" element={<Home data-id="element-20" data-mp="3dm5vhr4ku4d2" />} data-id="element-19" data-mp="3dlnukh6yz1yt" />
          </Routes>
        </main>
        <Footer data-id="element-21" data-mp="nwc0jp6vnpuo" />
      </div>
    </BrowserRouter>;
}